import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Plan, Role } from '@contenthub/shared';

interface WorkspaceState {
  workspace_id: string | null;
  workspace_name: string | null;
  project_id: string | null;
  project_name: string | null;
  plan: Plan;
  role: Role;
  credits: number;

  setWorkspace: (id: string, name: string, plan: Plan, role: Role) => void;
  setProject: (id: string, name: string) => void;
  setCredits: (n: number) => void;
  reset: () => void;
}

export const useWorkspace = create<WorkspaceState>()(
  persist(
    (set) => ({
      workspace_id: null,
      workspace_name: null,
      project_id: null,
      project_name: null,
      plan: 'starter',
      role: 'viewer',
      credits: 0,

      setWorkspace: (id, name, plan, role) =>
        set({ workspace_id: id, workspace_name: name, plan, role }),
      setProject: (id, name) => set({ project_id: id, project_name: name }),
      setCredits: (credits) => set({ credits }),
      reset: () => set({
        workspace_id: null, workspace_name: null,
        project_id: null, project_name: null,
        plan: 'starter', role: 'viewer', credits: 0,
      }),
    }),
    { name: 'contenthub.workspace' },
  ),
);
